import { render, staticRenderFns } from "./usd-circle.vue?vue&type=template&id=2e0510b2&"
import script from "./usd-circle.vue?vue&type=script&lang=js&"
export * from "./usd-circle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e0510b2')) {
      api.createRecord('2e0510b2', component.options)
    } else {
      api.reload('2e0510b2', component.options)
    }
    module.hot.accept("./usd-circle.vue?vue&type=template&id=2e0510b2&", function () {
      api.rerender('2e0510b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/usd-circle.vue"
export default component.exports